---
title: The Archive
lede: Where finished tasks go, with a record of what their run did and a way to run one again.
order: 32
part: Plan the work
---

The Archive keeps a record of every task whose session you closed, so you can see what was shipped without keeping finished sessions alive. Open it with the **Archive** icon at the foot of the navigator. Each workspace has its own.

![The Archive](media/archive-list.webp)

### What lands in it

A task arrives when you close its session, whether its work was merged or not. The band at the top counts them, for example `12 tasks · 9 merged · 3 closed · swept after 30 days`.

Each row starts with `MERGED`, or `CLOSED` for a task closed with nothing merged, then shows its title, the workflow it ran, its ticket, the pull request number if there was one, the date and the days left.

To keep a task off the archive, tick **Send the task back to the backlog** in the close dialog. It is offered only while nothing has merged, and never for a session reviewing a pull request.

### Find a task

The search field matches titles, tickets and workflows. With Jira or Trello connected, or tasks that came from them, a switch narrows the list to **All**, **Jira** or **Trello**. The list shows 25 tasks a page; **Older** and **Newer** move between pages.

### A record

Click a row to open its record.

On the left: the **Prompt** as written, the **Workflow**'s steps with each check's verdict (a step the run came back to says `×2`), **What happened** (each merge, push, pull request, rejection and close, dated as it happened), and the **Merge** message.

On the right: the model and effort, where it ran, the branch it merged into, where each repository was pushed and its pull request, how long it took, the files and lines changed, and under **Cut from** the branch each repository started from.

A task closed with nothing merged keeps its prompt, **What happened** and how it ran, with no **Merge** message and no files changed. If its run left no record at all, only the prompt and **Run again** remain.

![An archive record](media/archive-record.webp)

### Run again

**Run again**, in any record, starts a new task with the same title, prompt, workflow, repositories, branches, model, effort and placement, and opens its session. With no slot free, it waits on [the Board](/board). The record is unchanged.

Use it to retry a task that went wrong, or to rerun a recurring chore from last time's record.

### It empties itself

A record is deleted after **Keep archived tasks for** days, in **Settings › Sessions › Archive**: 30 by default, from 1 to 365. A workspace can set its own. Within three days of the end, a row's days left turn yellow and the band shows **DUE SOON**.

**Delete**, in a record, removes it now, after asking.
